// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3uw3S","row":"ProcedureTreatmentSummary_row__b7DRd"};